import { render, staticRenderFns } from "./AccordionComponent.vue?vue&type=template&id=fe49f630&"
import script from "./AccordionComponent.vue?vue&type=script&lang=js&"
export * from "./AccordionComponent.vue?vue&type=script&lang=js&"
import style0 from "./AccordionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports